const MainTitle = 'SISFOR';

const ENV_BASE_PATH = {
  DEV: null,
  SIT: null,
  PRE_PROD: null,
  PROD: null,

  DEFAULT: '/',
};

const basePath =
  ENV_BASE_PATH[process.env.REACT_APP_DEPLOY_ENV] || ENV_BASE_PATH.DEFAULT;

const baseRoutes = {
  public: {
    path: `${basePath}`,
    title: `Public - ${MainTitle}`,
  },
  private: {
    path: `${basePath}elearning/`,
    title: `Private - ${MainTitle}`,
  },
  auth: {
    path: `${basePath}auth/`,
    title: `Auth - ${MainTitle}`,
  },
};

const routes = {
  // auth
  auth: {
    path: `${baseRoutes.auth.path}`,
    title: `Auth - ${MainTitle}`,
  },
  otpAuth: {
    path: `${baseRoutes.auth.path}otp`,
    title: `OTP Auth - ${MainTitle}`,
  },
  authSSO: {
    path: `${baseRoutes.auth.path}sso`,
    title: `Auth SSO - ${MainTitle}`,
  },
  resetAuth: {
    path: `${baseRoutes.auth.path}reset`,
    title: `Reset Auth - ${MainTitle}`,
  },
  authSet: {
    path: `${baseRoutes.auth.path}set-region-province`,
    title: `Inserimento dati obbligatori - ${MainTitle}`,
  },
  //private
  home: {
    path: `${baseRoutes.private.path}`,
    title: `Home - ${MainTitle}`,
  },
  maintenance: {
    path: `${baseRoutes.private.path}manutenzione`,
    title: `${MainTitle}`,
  },
  notifications: {
    path: `${baseRoutes.private.path}notifiche`,
    title: `Notifiche - ${MainTitle}`,
  },
  notificationDetails: {
    path: `${baseRoutes.private.path}notifiche`,
    title: `Dettaglio notifica - ${MainTitle}`,
  },
  bookmarks: {
    path: `${baseRoutes.private.path}preferiti`,
    title: `Preferiti - ${MainTitle}`,
  },
  sessionManagement: {
    path: `${baseRoutes.private.path}gestisci-sessione`,
    title: `Gestisci sessione  - ${MainTitle}`,
  },
  faq: {
    path: `${baseRoutes.private.path}faq`,
    title: `FAQ - ${MainTitle}`,
  },
  notFound: {
    path: `${baseRoutes.private.path}404`,
    title: 'Not Found',
  },
  logout: {
    path: `${baseRoutes.private.path}logout`,
    title: 'Logout',
  },
  search: {
    path: `${baseRoutes.private.path}ricerca`,
    title: `Ricerca - ${MainTitle}`,
  },
  dashboard: {
    path: `${baseRoutes.private.path}progressi`,
    title: `I miei progressi - ${MainTitle}`,
  },
  courseDetails: {
    path: `${baseRoutes.private.path}progressi/dettaglio`,
    title: `Course - ${MainTitle}`,
  },
  fullCatalog: {
    path: `${baseRoutes.private.path}catalogo-completo`,
    title: `Catalogo completo - ${MainTitle}`,
  },
  catalog: {
    path: `${baseRoutes.private.path}catalogo`,
    title: `Catalogo - ${MainTitle}`,
  },
  news: {
    path: `${baseRoutes.private.path}news`,
    title: `News - ${MainTitle}`,
  },
  newsDetails: {
    path: `${baseRoutes.private.path}news/dettaglio`,
    title: `Dettaglio news - ${MainTitle}`,
  },
  documents: {
    path: `${baseRoutes.private.path}documenti`,
    title: `Documenti - ${MainTitle}`,
  },
  documentDetails: {
    path: `${baseRoutes.private.path}documenti/dettaglio`,
    title: `Dettaglio documento - ${MainTitle}`,
  },
  documentsExpert: {
    path: `${baseRoutes.private.path}scambio-documentale`,
    title: `Scambio documentale - ${MainTitle}`,
  },
  documentExpertDetails: {
    path: `${baseRoutes.private.path}scambio-documentale/dettaglio`,
    title: `Dettaglio scambio documentale - ${MainTitle}`,
  },
  newsletterDetails: {
    path: `${baseRoutes.private.path}newsletter/dettaglio`,
    title: `Dettaglio newsletter - ${MainTitle}`,
  },
  tutors: {
    path: `${baseRoutes.private.path}tutors`,
    title: `Tutors - ${MainTitle}`,
  },
  editProfile: {
    path: `${baseRoutes.private.path}profilo`,
    title: `Il mio profilo - ${MainTitle}`,
  },
  downloadCatalog: {
    path: `${baseRoutes.private.path}download-catalogo`,
    title: `Download catalogo  - ${MainTitle}`,
  },
  // tutor
  chooseCourseType: {
    path: `${baseRoutes.private.path}creazione-percorso-formativo`,
    title: `Creazione percorso formativo  - ${MainTitle}`,
  },
  createCourse: {
    path: `${baseRoutes.private.path}creazione-corso`,
    title: `Creazione corso  - ${MainTitle}`,
  },
  editCourse: {
    path: `${baseRoutes.private.path}gestione-corso`,
    title: `Gestione corso  - ${MainTitle}`,
  },
  scormList: {
    path: `${baseRoutes.private.path}catalogo-moduli`,
    title: `Lista moduli  - ${MainTitle}`,
  },
  tutorCourseList: {
    path: `${baseRoutes.private.path}catalogo-percorsi-formativi`,
    title: `Catalogo percorsi formativi  - ${MainTitle}`,
  },
  createEvent: {
    path: `${baseRoutes.private.path}creazione-evento`,
    title: `Creazione evento  - ${MainTitle}`,
  },
  editEvent: {
    path: `${baseRoutes.private.path}gestione-evento`,
    title: `Gestione evento  - ${MainTitle}`,
  },
  liveEventList: {
    path: `${baseRoutes.private.path}lista-eventi-live`,
    title: `Lista eventi live  - ${MainTitle}`,
  },
  liveEvent: {
    path: `${baseRoutes.private.path}evento-live`,
    title: `Evento live  - ${MainTitle}`,
  },
  // statistics
  downloadPdf: {
    path: `${baseRoutes.private.path}download-pdf`,
    title: `download-pdf  - ${MainTitle}`,
  },
  statistics: {
    path: `${baseRoutes.private.path}statistiche`,
    title: `Statistiche  - ${MainTitle}`,
  },
  userStatistics: {
    path: `${baseRoutes.private.path}statistiche/utente`,
    title: `Statistiche utente - ${MainTitle}`,
  },
  courseStatistics: {
    path: `${baseRoutes.private.path}statistiche/corso`,
    title: `Statistiche corso - ${MainTitle}`,
  },
  // groups
  groupList: {
    path: `${baseRoutes.private.path}i-miei-gruppi`,
    title: `I miei gruppi - ${MainTitle}`,
  },
  // supervisor
  tutorStatistics: {
    path: `${baseRoutes.private.path}statistiche/tutor`,
    title: `Statistiche tutor - ${MainTitle}`,
  },
  tutorDashboard: {
    path: `${baseRoutes.private.path}statistiche/dashboard-tutor`,
    title: `Supervisor - ${MainTitle}`,
  },
  sendNewsletter: {
    path: `${baseRoutes.private.path}invia-newsletter`,
    title: `Invia Newsletter - ${MainTitle}`,
  },
  approvalList: {
    path: `${baseRoutes.private.path}gestione-richieste-approvazione`,
    title: `Gestione richieste approvazione - ${MainTitle}`,
  },
  previewEvent: {
    path: `${baseRoutes.private.path}approvazione-evento`,
    title: `Approvazione evento - ${MainTitle}`,
  },
  logsList: {
    path: `${baseRoutes.private.path}logs/list`,
    title: `Elenco log - ${MainTitle}`,
  },
  // public site
  public: {
    path: `${baseRoutes.public.path}`,
    title: `Public - ${MainTitle}`,
  },
  publicFaq: {
    path: `${baseRoutes.public.path}faq`,
    title: `Faq - ${MainTitle}`,
  },
  publicNews: {
    path: `${baseRoutes.public.path}news`,
    title: `News - ${MainTitle}`,
  },
  publicNewsDetails: {
    path: `${baseRoutes.public.path}news/dettaglio`,
    title: `Dettaglio news - ${MainTitle}`,
  },
};

export default routes;
